export const complaintsTypes = {
    1: "Spam",
    2: "Violence",
    3: "Explicit Content",
    4: "Copyright",
    5: "Other",
};
